<div *ngIf="loading$ | async" class="cssload-container">
  <div class="cssload-speeding-wheel"></div>
</div>
